import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <div className="footer-logo-icon">🎓</div>
              <h3>CampusRecruit</h3>
            </div>
            <p className="footer-description">
              Connecting talented students with top companies. Your gateway to career success and professional growth.
            </p>
            <div className="social-links">
              <a href="#" className="social-link" aria-label="Facebook">📘</a>
              <a href="#" className="social-link" aria-label="Twitter">🐦</a>
              <a href="#" className="social-link" aria-label="LinkedIn">💼</a>
              <a href="#" className="social-link" aria-label="Instagram">📷</a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/placement-drives">Placement Drives</Link></li>
              <li><Link to="/colleges">Colleges</Link></li>
              <li><Link to="/companies">Companies</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>For Students</h4>
            <ul className="footer-links">
              <li><Link to="/student-register">Register as Student</Link></li>
              <li><Link to="/placement-drives">Browse Drives</Link></li>
              <li><Link to="/companies">Explore Companies</Link></li>
              <li><Link to="/colleges">Find Colleges</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>For Companies</h4>
            <ul className="footer-links">
              <li><Link to="/company-register">Register as Company</Link></li>
              <li><Link to="/login">Company Login</Link></li>
              <li><Link to="/contact">Partner With Us</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} CampusRecruit. All rights reserved.</p>
            <div className="footer-legal">
              <Link to="/about">Privacy Policy</Link>
              <span>|</span>
              <Link to="/about">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

